import { useCallback, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";

export default function AdminAnnouncements() {
  const [ann, setAnn] = useState({ title: "", body: "" });
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    const r = await api.get("/announcements");
    setItems(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  async function publish() {
    if (!ann.title || !ann.body) return toast.error("Title and body are required");
    try {
      await api.post("/admin/announcements", ann);
      toast.success("Announcement published");
      setAnn({ title: "", body: "" });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || e.message); }
  }

  return (
    <div className="space-y-6 max-w-3xl" data-testid="admin-announcements">
      <div className="rounded-3xl bg-card border border-border p-6 space-y-4">
        <h3 className="font-display text-xl font-bold">New announcement</h3>
        <div>
          <Label>Title</Label>
          <Input value={ann.title} onChange={(e) => setAnn({ ...ann, title: e.target.value })}
            data-testid="ann-title" className="mt-1.5 rounded-xl h-11" />
        </div>
        <div>
          <Label>Body</Label>
          <Textarea value={ann.body} onChange={(e) => setAnn({ ...ann, body: e.target.value })}
            data-testid="ann-body" className="mt-1.5 rounded-2xl min-h-[120px]" />
        </div>
        <Button onClick={publish} data-testid="ann-publish"
          className="rounded-full royal-gradient border-0 text-white btn-lift">
          <Megaphone className="h-4 w-4 mr-1.5" /> Publish
        </Button>
      </div>

      <div className="rounded-3xl bg-card border border-border overflow-hidden">
        <p className="px-5 py-3 text-xs uppercase tracking-widest text-muted-foreground border-b border-border">Recent</p>
        {items.map((a) => (
          <div key={a.id} className="px-5 py-4 border-b border-border last:border-0">
            <p className="font-semibold">{a.title}</p>
            <p className="text-sm text-muted-foreground mt-1">{a.body}</p>
            <p className="text-xs text-muted-foreground mt-2">{new Date(a.created_at).toLocaleString()}</p>
          </div>
        ))}
        {items.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground">No announcements yet.</div>}
      </div>
    </div>
  );
}
